export const formatDateForGoogle = (date: Date): string | null => {
  const newDate = new Date(date).toISOString();
  if (newDate) {
    return newDate.replaceAll(':', '').replaceAll('-', '').replaceAll('.', '');
  } else {
    return null;
  }
};
